module.exports = __webpack_public_path__ + "img/Layer_3.f46e3c9e.png";